import { render, staticRenderFns } from "./BroadcastEdit.vue?vue&type=template&id=5cbd4cd7&scoped=true&"
import script from "./BroadcastEdit.vue?vue&type=script&lang=js&"
export * from "./BroadcastEdit.vue?vue&type=script&lang=js&"
import style0 from "./BroadcastEdit.vue?vue&type=style&index=0&id=5cbd4cd7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cbd4cd7",
  null
  
)

export default component.exports